import React from 'react';
import { useBarcode } from 'react-barcodes';

export default function BarCode({ textobarcode }) {
	const { inputRef } = useBarcode({
		value: textobarcode === '' ? 'vacio' : textobarcode,
	});
	return <img alt={textobarcode} ref={inputRef} />;
}
